 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import PRF01 from '@/components/prf01'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import ACK from '@/components/ack'
 import INTRO from '@/components/intro'
 import CHAP01 from '@/components/chap01'
 import CHAP02 from '@/components/chap02'
 import CHAP03 from '@/components/chap03'
 import CHAP04 from '@/components/chap04'
 import CHAP05 from '@/components/chap05'
 import CHAP06 from '@/components/chap06'
 import CHAP07 from '@/components/chap07'
 import CHAP08 from '@/components/chap08'
 import CHAP09 from '@/components/chap09'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import LOVE_2 from '@/components/love_2'
 import BACK01 from '@/components/back01'
 import BACK02 from '@/components/back02'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
 		{
 			"path" : "/chap01",
 			"name" : "chap01",
 			"component" : CHAP01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js